module.exports = __webpack_public_path__ + "img/payu.ac2ccad.svg";